import { post } from "helpers/api_helper/ApiHelpers/apiHelpers"
import * as url from "helpers/url_helper/url_helper"

export const getChargebackMonitoringList = (record) => post(url.GET_CHARGEBACK_MONITORING_LIST,record)
export const getChargebackMonitoringSearch = (record) => post(url.GET_CHARGEBACK_MONITORING_SEARCH, record);